 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","act":"act","activities~purchase":"activities~purchase","purchase":"purchase","activity":"activity","application":"application","activities~member~privacy~shop-live~shop-live-1":"activities~member~privacy~shop-live~shop-live-1","activities":"activities","privacy~shop-live~shop-live-1":"privacy~shop-live~shop-live-1","privacy":"privacy","service-new":"service-new","combine~hotel~member~shop~shop-live~shop-live-1~transfer":"combine~hotel~member~shop~shop-live~shop-live-1~transfer","kyb~member~ranking~shop":"kyb~member~ranking~shop","shop":"shop","kyb":"kyb","shop-live":"shop-live","dispute~member":"dispute~member","member":"member","shop-live-1":"shop-live-1","company~international":"company~international","international":"international","ranking":"ranking","order":"order","auth":"auth","bankRisk":"bankRisk","login":"login","hotel":"hotel","combine":"combine","transfer":"transfer","company":"company","declare":"declare","dispute":"dispute","economic-investigation":"economic-investigation","financial-insurance":"financial-insurance","foreigner":"foreigner","landingPage":"landingPage","logistics":"logistics","misc":"misc","no-support":"no-support","service":"service","standard":"standard","survey":"survey","trade-insurance":"trade-insurance","warehouse":"warehouse"}[chunkId]||chunkId) + "." + {"404":"a1d02a46","act":"3680722e","activities~purchase":"f268bc84","purchase":"71271860","activity":"849c7b71","application":"ecdfa59d","chunk-135f0a52":"ee7c6757","chunk-19b97388":"1570c1f4","chunk-35d026d2":"d2d6418a","chunk-7a902254":"92ed8fc3","chunk-b5c4886a":"af8578cc","activities~member~privacy~shop-live~shop-live-1":"c20bef8e","activities":"71186478","privacy~shop-live~shop-live-1":"92ca4645","privacy":"04dd6ee7","chunk-e5b0403c":"ec8cab86","chunk-325c1b09":"95b31a37","chunk-4c0b5c36":"8cca568f","chunk-086ae155":"05cd44d8","chunk-4c55bbb0":"b9c37ca4","chunk-5187938e":"3679361b","chunk-616639ae":"ab7d1406","chunk-75590050":"4b11cf63","chunk-bbf92eb0":"f8f4265f","service-new":"580907b4","combine~hotel~member~shop~shop-live~shop-live-1~transfer":"84d7bf41","kyb~member~ranking~shop":"4f567387","shop":"8c8eca4a","kyb":"75b3643d","shop-live":"f74b9a20","dispute~member":"cc46e01e","member":"f68db2e7","shop-live-1":"00773df9","company~international":"243c646b","international":"05157fc8","ranking":"746b606e","order":"b82d5d73","auth":"72dbbc3b","bankRisk":"5548456a","login":"ffca2169","chunk-010fadba":"cade81df","hotel":"4a3c422a","combine":"079d2f58","transfer":"1c4af11a","company":"bc4a584b","declare":"3079da44","dispute":"208e8c68","economic-investigation":"2b5c52b7","financial-insurance":"43ad8e36","foreigner":"0f0939ef","landingPage":"89cdaec1","logistics":"52a58a93","misc":"0476542f","no-support":"0eb397de","service":"9d236f43","standard":"7ec52847","survey":"8861b1cf","trade-insurance":"0dbb5972","warehouse":"f1603e7f","chunk-575b13e2":"cc82a354"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"act":1,"activities~purchase":1,"purchase":1,"activity":1,"application":1,"chunk-135f0a52":1,"chunk-19b97388":1,"chunk-35d026d2":1,"chunk-7a902254":1,"activities~member~privacy~shop-live~shop-live-1":1,"activities":1,"privacy~shop-live~shop-live-1":1,"privacy":1,"chunk-325c1b09":1,"chunk-4c0b5c36":1,"chunk-086ae155":1,"chunk-4c55bbb0":1,"chunk-5187938e":1,"chunk-616639ae":1,"chunk-75590050":1,"chunk-bbf92eb0":1,"service-new":1,"kyb~member~ranking~shop":1,"shop":1,"kyb":1,"shop-live":1,"dispute~member":1,"member":1,"shop-live-1":1,"company~international":1,"international":1,"ranking":1,"order":1,"auth":1,"bankRisk":1,"login":1,"chunk-010fadba":1,"hotel":1,"combine":1,"transfer":1,"company":1,"declare":1,"dispute":1,"economic-investigation":1,"financial-insurance":1,"foreigner":1,"landingPage":1,"logistics":1,"misc":1,"no-support":1,"service":1,"standard":1,"survey":1,"trade-insurance":1,"warehouse":1,"chunk-575b13e2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","act":"act","activities~purchase":"activities~purchase","purchase":"purchase","activity":"activity","application":"application","activities~member~privacy~shop-live~shop-live-1":"activities~member~privacy~shop-live~shop-live-1","activities":"activities","privacy~shop-live~shop-live-1":"privacy~shop-live~shop-live-1","privacy":"privacy","service-new":"service-new","combine~hotel~member~shop~shop-live~shop-live-1~transfer":"combine~hotel~member~shop~shop-live~shop-live-1~transfer","kyb~member~ranking~shop":"kyb~member~ranking~shop","shop":"shop","kyb":"kyb","shop-live":"shop-live","dispute~member":"dispute~member","member":"member","shop-live-1":"shop-live-1","company~international":"company~international","international":"international","ranking":"ranking","order":"order","auth":"auth","bankRisk":"bankRisk","login":"login","hotel":"hotel","combine":"combine","transfer":"transfer","company":"company","declare":"declare","dispute":"dispute","economic-investigation":"economic-investigation","financial-insurance":"financial-insurance","foreigner":"foreigner","landingPage":"landingPage","logistics":"logistics","misc":"misc","no-support":"no-support","service":"service","standard":"standard","survey":"survey","trade-insurance":"trade-insurance","warehouse":"warehouse"}[chunkId]||chunkId) + "." + {"404":"500e800f","act":"c4892d19","activities~purchase":"8d8d7036","purchase":"abc6cea8","activity":"76ef6002","application":"ed48f09a","chunk-135f0a52":"3f88332c","chunk-19b97388":"19396631","chunk-35d026d2":"176a54d6","chunk-7a902254":"0e2a6ce5","chunk-b5c4886a":"31d6cfe0","activities~member~privacy~shop-live~shop-live-1":"9a606e5c","activities":"7325c48d","privacy~shop-live~shop-live-1":"40e9f3d4","privacy":"1ec6a3d4","chunk-e5b0403c":"31d6cfe0","chunk-325c1b09":"f4ec9651","chunk-4c0b5c36":"ffe264e7","chunk-086ae155":"677469ac","chunk-4c55bbb0":"deac6813","chunk-5187938e":"123444be","chunk-616639ae":"b44d6e18","chunk-75590050":"6ceace88","chunk-bbf92eb0":"744b9275","service-new":"08e92a5d","combine~hotel~member~shop~shop-live~shop-live-1~transfer":"31d6cfe0","kyb~member~ranking~shop":"cc1b89e8","shop":"4cc944d1","kyb":"0bda4d96","shop-live":"1d673b33","dispute~member":"8d022048","member":"dbffb0f1","shop-live-1":"ad05081c","company~international":"7a8de354","international":"516a4987","ranking":"09c68fa0","order":"a0382075","auth":"d5e211a7","bankRisk":"eee43975","login":"be7459e9","chunk-010fadba":"fe179894","hotel":"320f74c6","combine":"b0517e9f","transfer":"df17b239","company":"f1a24348","declare":"48c078ed","dispute":"9951bf91","economic-investigation":"bc323dd6","financial-insurance":"548ec21c","foreigner":"1c198435","landingPage":"4ce4accc","logistics":"f7848aef","misc":"822a5133","no-support":"88d91ab4","service":"aebbe1bf","standard":"3194b566","survey":"a4d77e0d","trade-insurance":"76682eae","warehouse":"37e38c96","chunk-575b13e2":"df87e569"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//assets.chinagoods.com/www/zh/2.11.18/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"icons","lib-swiper","vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
